/*
 * @Author: your name
 * @Date: 2021-09-01 13:24:05
 * @LastEditTime: 2021-10-12 20:30:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lwdgis-ui\src\V3\js\map.js
 */
import 'ol/ol.css';
import { Map, View, Overlay } from 'ol'
import ImageLayer from 'ol/layer/Image'
import TileLayer from 'ol/layer/Tile'

import { Polygon, MultiPolygon } from "ol/geom";
import { ol } from "ol";
import { ScaleLine, Zoom, defaults as defaultControls, OverviewMap } from "ol/control";

import XYZ from 'ol/source/XYZ'
import ImageWMS from 'ol/source/ImageWMS'
import TileWMS from 'ol/source/TileWMS'
import VectorSource from 'ol/source/Vector';
import GeoJSONFormat from 'ol/format/GeoJSON';
import VectorLayer from 'ol/layer/Vector';
import { transform, transformExtent, fromLonLat, Projection } from 'ol/proj';

import { Circle, Stroke, Style, Fill } from 'ol/style';
import Point from 'ol/geom/Point';
import Feature from 'ol/Feature';
import axios from 'axios'
import projzh from 'projzh'


let key = '719db4cca683b30963c21ef4211504ec'
// 初始化图层，加载高德地图
// 参数: div_container，承载地图的div容器
// 参数：centerLonLat，地图中心点的经纬度坐标，WGS84坐标系
// 参数：zoomLevel，地图的缩放级别
// 返回值：OpenLayers Map对象
function initMap(div_container, centerLonLat, zoomLevel) {
    let layers = [
        new TileLayer({
            source: new XYZ({
                // 遥感影像
                url: 'http://t7.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=' + key,
                wrapX: false
            }),
            zIndex: 1,

            title: '天地图底图'
        }),
        new TileLayer({
            source: new XYZ({
                // 遥感影像
                url: 'http://t7.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=' + key,
                wrapX: false
            }),
            zIndex: 2,

            title: '天地图底图注记'
        })
    ]
    let ol_map = new Map({
        target: document.getElementById(div_container),
        view: new View({
            projection: 'EPSG:3857',
            center: transform(centerLonLat, 'EPSG:4326', "EPSG:3857"),
            zoom: zoomLevel,
        }),
        controls: [],


    });
    // ol_map.addLayer(layers[0])
    // ol_map.addLayer(layers[1])
    ol_map.getLayers().insertAt(0, layers[0]);
    ol_map.getLayers().insertAt(1, layers[1]);
    // 添加比例尺
    const scaleLine = new ScaleLine({
        // bar: true,
        // text: true,
        // minWidth: 125,
        //设置度量单位为米
        units: "metric",
        target: "scalebar",
        className: "scale-line",
    });
    // 添加缩放
    const zoom = new Zoom({
        className: 'zoom'
    })
    ol_map.addControl(scaleLine);
    ol_map.addControl(zoom);

    return ol_map
}
function changeBaseLayer(ol_map, baseLayerType) {
    var baseLayer = null;
    var baseLayerLabel = null;
    switch (baseLayerType) {
        case 'map':
            baseLayer = new TileLayer({
                source: new XYZ({
                    url: 'http://t7.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=' + key,
                    wrapX: false
                }),
                zIndex: 1,

                title: '天地图底图'
            });
            baseLayerLabel = new TileLayer({
                source: new XYZ({
                    url: 'http://t7.tianditu.gov.cn/cva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=' + key,
                    wrapX: false
                }),
                zIndex: 2,

                title: '天地图底图注记'
            });
            break;
        case 'image':
            baseLayer = new TileLayer({
                source: new XYZ({
                    // 遥感影像
                    url: 'http://t7.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=' + key,
                    wrapX: false
                }),
                zIndex: 1,

                title: '天地图底图'
            });
            baseLayerLabel = new TileLayer({
                source: new XYZ({
                    // 遥感影像
                    url: 'http://t7.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=' + key,
                    wrapX: false
                }),
                zIndex: 2,

                title: '天地图底图注记'
            });
            break;
        case 'terrain':
            baseLayer = new TileLayer({
                source: new XYZ({
                    url: 'http://t7.tianditu.gov.cn/ter_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=ter&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=' + key,
                    wrapX: false
                }),
                title: '天地图底图',
                zIndex: 1,

                visible: true
            });
            baseLayerLabel = new TileLayer({
                source: new XYZ({
                    url: 'http://t7.tianditu.gov.cn/cta_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cta&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=' + key,
                    wrapX: false
                }),
                title: '天地图底图注记',
                zIndex: 2,

                visible: true
            });
            break;
    }

    var layerArr = ol_map.getLayers();
    ol_map.getLayers().forEach(layer => {
        if (layer != undefined && (layer.getProperties().title == '天地图底图' ||
            layer.getProperties().title == '天地图底图注记')
        ) {
            ol_map.removeLayer(layer)
        }
    })
    // ol_map.removeLayer(layerArr.getArray()[0]);
    // ol_map.removeLayer(layerArr.getArray()[1]);
    ol_map.getLayers().insertAt(0, baseLayer);
    ol_map.getLayers().insertAt(1, baseLayerLabel);

}
// 加载WFS图层
function addWfsLayer(wfsURL, wfsStyle, title, wfsZindex) {
    let vtSource = new VectorSource({
        format: new GeoJSONFormat(),
        loader: function (extent, resolution, projection) {
            axios.get(wfsURL).then((res) => {
                var featureList = vtSource
                    .getFormat()
                    .readFeatures(res.data)
                featureList.forEach((item, index) => {
                    item.setGeometry(
                        item
                            .getGeometry()
                            .transform('EPSG:4326', 'EPSG:3857')
                    )
                    vtSource.addFeature(item)
                })
            })
        },
    })

    let vtLayer = new VectorLayer({
        source: vtSource,
        style: wfsStyle,
        zIndex: wfsZindex,
        title: title,
        //style: null
    })
    return vtLayer
}

// 加载WMS图层
// 参数：ol_map, OpenLayers Map对象
// 参数: url，WMS的基地址
// 参数: layerName，要加载WMS图层的名称
function addWMSLayer(ol_map, url, layerName) {
    //debugger
    let tLayer = new TileLayer({
        source: new TileWMS({
            //url: 'http://localhost:8088/geoserver/szhgis/wms',
            url: url,
            params: {
                'LAYERS': layerName
            }
        })
    })

    ol_map.addLayer(tLayer);
}

export { initMap, changeBaseLayer, addWfsLayer, addWMSLayer }



// WEBPACK FOOTER //
// ./src/V3/js/map.js